<template>
  <div>
    <PayPal
      :plan_ids="[
        { title: 'Scout Monat', id: 'P-68V65133UA612230JLY4XGUI', price: '9,99€' },
        { title: 'Scout Jahr', id: 'P-80L68994S5722244LLY6AFBY', price: '99,90€' },
      ]"
    />
  </div>
</template>

<script>
import PayPal from '@/components/PayPal';

export default {
  components: { PayPal },
  data: () => ({
    month: true,
  }),
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
</style>
